module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABoAgMAAADDWjv0AAAACVBMVEUAAABAQEBAQEC542CNAAAAAnRSTlMAgJsrThgAAAA/SURBVDjLY2AYVIBr1aoFEIJEHp0puocLvb1JZjyMgiGRrqVWLUHiZa1aiZSuV61aheRwGvNQbcdw2Wi6RgcAqTmAeynzrDIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/fullscreen_2x.png
// module id = 2110
// module chunks = 1